import { computed } from 'vue';
import { useRoute } from 'vue-router';

export function useRouting() {
  const route = useRoute();
  
  // Returns object with all parameters
  const queryParams = computed(() => route.query);
  // { param1: 'ABC', param2: 'XYZ' }
  
  // Returns array of objects
  const queryParamsArray = computed(() => {
    return Object.entries(route.query).map(([key, value]) => ({
      key,
      value
    }));
  });
  // [{ key: 'param1', value: 'ABC' }, { key: 'param2', value: 'XYZ' }]
  
  // Check if a parameter exists
  const hasParam = (paramName) => window.location.search.indexOf(paramName + '=') !== -1;
  
  // Returns all search parameters as an object
  const searchParams = computed(() => {
    const customObj = Object.fromEntries(new URLSearchParams(window.location.search));
    return customObj;
  });
  
  return {
    queryParams,
    queryParamsArray,
    hasParam,
    searchParams
  };
}